import * as types from '../constants/ActionTypes';
import MealStockService from "../services/meal_stock.service";
import { handleAPIError } from "./common.actions";

const setAPIState = apiState => ({
  type: types.SET_STOCK_API_STATE,
  apiState
});

const receiveLevels = levels => ({
  type: types.RECEIVE_STOCK_LEVELS,
  levels
});

const receiveDetail = (mealId, entries) => ({
  type: types.RECEIVE_STOCK_DETAIL,
  mealId,
  entries
});

export const getStockLevels = () => dispatch => {
  dispatch(setAPIState("get"));
  return MealStockService.getStockLevels().then(
    response => {
      dispatch(receiveLevels(response.data));
    },
    handleAPIError(dispatch));
};

export const getStockDetail = mealId => dispatch => {
  return MealStockService.getStockDetail(mealId).then(
    response => {
      dispatch(receiveDetail(mealId, response.data));
    },
    handleAPIError(dispatch));
};

// After any mutation, re-fetch — stock is derived, so a refresh is the source of truth.
export const saveAdjustment = adjustment => dispatch => {
  dispatch(setAPIState("save"));
  return MealStockService.saveAdjustment(adjustment).then(
    () => {
      dispatch(getStockLevels());
      if (adjustment.mealId) {
        dispatch(getStockDetail(adjustment.mealId));
      }
    },
    handleAPIError(dispatch));
};

export const reconcileStock = (mealId, target) => dispatch => {
  dispatch(setAPIState("save"));
  return MealStockService.reconcile(mealId, target).then(
    () => {
      dispatch(getStockLevels());
      dispatch(getStockDetail(mealId));
    },
    handleAPIError(dispatch));
};

export const deleteAdjustment = (id, mealId) => dispatch => {
  dispatch(setAPIState("delete"));
  return MealStockService.deleteAdjustment(id).then(
    () => {
      dispatch(getStockLevels());
      if (mealId) {
        dispatch(getStockDetail(mealId));
      }
    },
    handleAPIError(dispatch));
};
